import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Mail, Phone, MapPin, Linkedin } from 'lucide-react';
import Logo from './Logo';
import { contactInfo } from '../mock';

export default function Footer() {
  return (
    <footer className="bg-[#14101A] text-[#E9DDE2]">
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Logo tone="light" />
            <p className="mt-6 text-[15px] leading-relaxed text-white/60 max-w-md">
              Specialist staffing for semiconductor, chip design, automotive,
              aerospace and industrial engineering companies. Permanent,
              project-based and RPO — under one accountable partner.
            </p>
            <Link
              to="/contact"
              className="mt-8 group inline-flex items-center gap-2 text-[15px] text-white border-b border-white/20 hover:border-[#E7A9B9] pb-1"
            >
              Start a conversation
              <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-[11px] uppercase tracking-[0.22em] text-white/40 mb-4">Company</h4>
            <ul className="space-y-3 text-[14px]">
              <li><Link to="/about" className="hover:text-white text-white/70">About</Link></li>
              <li><Link to="/services" className="hover:text-white text-white/70">Services</Link></li>
              <li><Link to="/industries" className="hover:text-white text-white/70">Industries</Link></li>
              <li><Link to="/case-studies" className="hover:text-white text-white/70">Case Studies</Link></li>
              <li><Link to="/careers" className="hover:text-white text-white/70">Careers</Link></li>
              <li><Link to="/expertise" className="hover:text-white text-white/70">Expertise</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-[11px] uppercase tracking-[0.22em] text-white/40 mb-4">Services</h4>
            <ul className="space-y-3 text-[14px]">
              <li><Link to="/services#permanent-placement" className="hover:text-white text-white/70">Permanent Placement</Link></li>
              <li><Link to="/services#project-staffing" className="hover:text-white text-white/70">Project Staffing</Link></li>
              <li><Link to="/services#rpo" className="hover:text-white text-white/70">RPO Solution</Link></li>
              <li className="pt-2 mt-2 border-t border-white/10">
                <a href={`${process.env.REACT_APP_BACKEND_URL}/api/pitch-deck`} download className="inline-flex items-center gap-1.5 text-[#E7A9B9] hover:text-white">
                  Download pitch deck <ArrowUpRight size={13} />
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-[11px] uppercase tracking-[0.22em] text-white/40 mb-4">Get in touch</h4>
            <ul className="space-y-3 text-[14px] text-white/70">
              <li className="flex items-start gap-2"><Mail size={15} className="mt-0.5 text-[#E7A9B9]" /> {contactInfo.email}</li>
              <li className="flex items-start gap-2"><Phone size={15} className="mt-0.5 text-[#E7A9B9]" /> {contactInfo.phone}</li>
              <li className="flex items-start gap-2"><MapPin size={15} className="mt-0.5 text-[#E7A9B9]" /> {contactInfo.address}</li>
              <li className="flex items-start gap-2"><Linkedin size={15} className="mt-0.5 text-[#E7A9B9]" /> linkedin.com/company/erbity</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[13px] text-white/40">
          <span>© {new Date().getFullYear()} Erbity Private Limited. All rights reserved.</span>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-white/80">Privacy</a>
            <a href="#" className="hover:text-white/80">Terms</a>
            <span className="hidden md:inline">Talent . Engineered</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
